var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "compareListOffer" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("img", {
      staticClass: "compareListOffer__img",
      attrs: { src: "/images/s/gakko_compare.png" },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "compareListOffer__loginBtnWrapper" }, [
      _c(
        "a",
        {
          staticClass: "compareListOffer__loginBtn",
          attrs: { href: _vm.compareLink },
          on: {
            click: function ($event) {
              return _vm.$emit("click-go-compare", $event)
            },
          },
        },
        [_vm._v("比較機能を使ってみる")]
      ),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "compareList__description" }, [
      _vm._v("※比較機能はスマートフォンでのご利用を推奨しています。"),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "compareListOffer__descriptionWrapper" }, [
      _c("div", { staticClass: "compareListOffer__fukidashiWrapper" }, [
        _c("p", { staticClass: "compareListOffer__fukidashi" }, [
          _vm._v("学校の主要情報が簡単に比較できる！"),
        ]),
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "compareListOffer__dotImg",
        attrs: { src: "/images/s/dot_left.png" },
      }),
      _vm._v(" "),
      _c("p", { staticClass: "compareListOffer__description__text" }, [
        _vm._v("\n      会員限定の新機"),
        _c("span", { staticClass: "compareListOffer__description--letter7" }, [
          _vm._v("能"),
        ]),
        _vm._v(" "),
        _c("br", { staticClass: "break332" }),
        _c(
          "span",
          { staticClass: "compareListOffer__description__colorText" },
          [
            _vm._v("「学校比較"),
            _c(
              "span",
              { staticClass: "compareListOffer__description--letter6" },
              [_vm._v("」")]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "compareListOffer__dotImg",
        attrs: { src: "/images/s/dot_right.png" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }